import { map, switchMap } from 'rxjs/operators';
import { Inject, Injectable, Optional } from '@angular/core';
import { FhirApiService } from '../api/fhir-api.sevice';
import { ConsentService } from './consent.service';
import { UserService } from '../user.service';
import { PractitionerProviderAdapter } from '../../data/providers/practitioner-provider.model';
import { PractitionerProvidersService } from '../../data/providers/practitioner-providers.service';
import { Observable, of } from 'rxjs';
import { ReducerManager, Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class ConsentPractitionerProvidersService extends PractitionerProvidersService {
  consentProviderIdentifiers$: Observable<string[]>;

  constructor(
    @Inject('dataname') @Optional() dataName: string,
    protected adapter: PractitionerProviderAdapter,
    protected fhirApi: FhirApiService,
    protected userService: UserService,
    protected consentService: ConsentService,
    protected store: Store,
    protected manager: ReducerManager,
  ) {
    super(
      dataName || 'consent-practitioner-providers',
      adapter,
      fhirApi,
      userService,
      store,
      manager,
    );
  }

  fetchPractitionerProvidersWithConsentData() {
    return this.consentService.fetchConsentData$().pipe(
      map((permissions) =>
        permissions
          .map(({ providerId }) => providerId)
          .filter((providerId) => providerId),
      ),
      switchMap((identifiers) => {
        const uniqueIdentifiers = [...new Set(identifiers)];

        if (uniqueIdentifiers?.length) {
          const params = {
            '_include:iterate': 'Organization:partof',
          };

          const localIdentifiers = uniqueIdentifiers.map(
            (id) => `urn:oid:${id.replace('@', '|')}`,
          );

          return this.searchItems$({
            ...params,
            'practitioner.identifier': localIdentifiers.join(','),
            'organization.active': true,
            _count: 1000,
          }).pipe(
            map((providers) => {
              // Due to intersections between organizations which might include the same provider,
              // we need to filter duplicated providers
              const seenIdentifiers = new Set<string>();

              return providers.filter((provider) => {
                const identifier = provider.identifier?.trim().toLowerCase();

                if (!identifier) return true;
                if (seenIdentifiers.has(identifier)) return false;

                seenIdentifiers.add(identifier);
                return true;
              });
            }),
          );
        } else {
          return of(null);
        }
      }),
    );
  }
}
